import React from "react";
import styled from "styled-components";

const FUSIONMSI_LOGO_SRC = "/brand/fusionmsi/fusionmsi-logo.svg";

const LogoWrapper = styled.div`
  height: 32px;

  img {
    height: 32px;
    width: auto;
    aspect-ratio: 1000 / 1120;
  }
`;

const Logo = () => (
  <LogoWrapper>
    <img src={FUSIONMSI_LOGO_SRC} alt="FusionMSI" />
  </LogoWrapper>
);

export default Logo;
